<script setup lang="ts">
import { getStrCell } from '@/utils/file';
import KBtn from '@/components/btns/KBtn.vue';

export interface Stop {
  name?: string;
  isTruckHere?: boolean;
  isTruckBefore?: boolean;
  disabled?: boolean;
}

export interface Props {
  stops?: Stop[];
}
const props = withDefaults(defineProps<Props>(), {
  stops: () => [],
});
const emit = defineEmits<{
  markerClick: [stopNum: number, stop: Stop];
}>();

function handleMarkerClick(stopNum: number, stop: Stop): void {
  emit('markerClick', stopNum, stop);
}
</script>

<template>
  <div :class="$style.wideJobStopDiagram" data-testid="wideJobStopDiagram">
    <div :class="$style.stops">
      <div :class="$style.road"></div>
      <div v-if="!props.stops.length" :class="$style.stop">
        <div :class="$style.numMarkerTitle">
          <div :class="$style.markerWrapper">
            <KBtn
              :class="$style.markerBtn"
              size="sm"
              variant="outlined"
              icon="mdi-map-marker"
              :disabled="true"
              rounded="circle"
              @click="false"
            >
            </KBtn>
          </div>
        </div>
      </div>
      <div
        v-for="(stop, index) in props.stops"
        :key="index"
        :class="$style.stop"
      >
        <div
          v-if="stop.isTruckHere"
          :class="[$style.truck, { [$style.truckBefore]: stop.isTruckBefore }]"
        >
          <v-icon icon="mdi-truck-fast-outline"></v-icon>
        </div>
        <div :class="$style.numMarkerTitle">
          <div :class="$style.stopNum">Stop {{ index + 1 }}</div>
          <div :class="$style.markerWrapper">
            <KBtn
              :class="$style.markerBtn"
              size="sm"
              variant="outlined"
              icon="mdi-map-marker"
              :disabled="stop.disabled"
              :loading="false"
              rounded="circle"
              @click="handleMarkerClick(index + 1, stop)"
            >
            </KBtn>
          </div>
          <div :class="$style.stopTitle">{{ getStrCell(stop.name) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.wideJobStopDiagram {
  line-height: 1.4;
}
  .stops {
    display: flex;
    position: relative;
    z-index: 0;
  }
    .road {
      height: 1px;
      background-color: colors.$color-text-tertiary;
      width: 100%;
      position: absolute;
      z-index: -1;
      margin-top: 49px;
    }
    .stop {
      padding-left: 3rem;
      padding-right: 3rem;
      width: 100%;
    }
    .stop + .stop {
      padding-left: calc(3rem + 1px);
    }
      .truck {
        color: colors.$color-text-secondary;
        font-size: 20px;
        position: absolute;
        margin-top: 20px;
        margin-left: 65px;
      }
      .truckBefore {
        margin-left: -40px;
      }
      .numMarkerTitle {
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        min-height: 97px;
      }
        .markerWrapper {
          background-color: colors.$color-white;
          margin: 6px auto 6px 12px;
        }
          .markerBtn {
            border: 3px solid;
            width: 34px !important;
            height: 34px !important;
            font-size: 14px !important;
          }
          .stopNum {
            color: colors.$color-text-tertiary;
            font-size: 18px;
            font-weight: 500;
          }
          .stopTitle {
            color: colors.$color-text-secondary;
            font-size: 18px;
            font-weight: 500;
          }
</style>
